"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.string.link.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.map.js");
var _react = _interopRequireWildcard(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _FemaGoModal = _interopRequireDefault(require("../../go/components/common/modal/FemaGoModal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactHtmlParser = _interopRequireDefault(require("react-html-parser"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var TYPEOPTS = {
  success: {
    icon: 'check circle',
    bgColor: 'green'
  },
  warning: {
    icon: 'exclamation triangle',
    bgColor: 'yellow'
  },
  info: {
    icon: 'info circle',
    bgColor: 'blue'
  },
  error: {
    icon: 'exclamation circle',
    bgColor: 'red'
  }
};
var AlertHeader = /*#__PURE__*/function (_Component) {
  _inherits(AlertHeader, _Component);
  var _super = _createSuper(AlertHeader);
  function AlertHeader() {
    _classCallCheck(this, AlertHeader);
    return _super.apply(this, arguments);
  }
  _createClass(AlertHeader, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Message.Header, null, _lodash.default.upperFirst(this.props.children));
    }
  }]);
  return AlertHeader;
}(_react.Component);
var Alert = /*#__PURE__*/function (_Component2) {
  _inherits(Alert, _Component2);
  var _super2 = _createSuper(Alert);
  function Alert(props) {
    var _this;
    _classCallCheck(this, Alert);
    _this = _super2.call(this, props);
    _this.handleDismiss = function () {
      _this.setState({
        visible: false
      });
    };
    _this.createLink = function (link, linkText) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: link
      }, " ", linkText, " >>");
    };
    _this.goToLocation = function (sectionTitle) {
      var _this$props = _this.props,
        configContents = _this$props.configContents,
        config = _this$props.config;
      var sectionList = configContents ? configContents : config[0].contents;
      var location = sectionList.findIndex(function (section) {
        return section.title === sectionTitle;
      });
      var newLocation = 'contents[' + "".concat(location) + ']';
      _this.props.navToSpecificLocation(newLocation);
    };
    _this.state = {
      dismissable: false,
      showTipsModalVisible: false,
      visible: true
    };
    return _this;
  }
  _createClass(Alert, [{
    key: "toggleToolTipsModal",
    value: function toggleToolTipsModal(action) {
      this.setState({
        showTipsModalVisible: !this.state.showTipsModalVisible
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        header = _this$props2.header,
        content = _this$props2.content,
        type = _this$props2.type,
        alertType = _this$props2.alertType,
        paragraph = _this$props2.paragraph,
        dismissable = _this$props2.dismissable,
        size = _this$props2.size,
        link = _this$props2.link,
        linkText = _this$props2.linkText,
        onDismiss = _this$props2.onDismiss,
        htmlContent = _this$props2.htmlContent,
        externalLink = _this$props2.externalLink,
        popup = _this$props2.popup,
        sectionTitle = _this$props2.sectionTitle,
        validationErrors = _this$props2.validationErrors,
        id = _this$props2.id,
        hideIcon = _this$props2.hideIcon;
      var opts = TYPEOPTS[alertType || type];
      var externalLinkCode;
      var popupCode;
      var navToSectionMessage;
      var invalidValidationErrors = _lodash.default.filter(validationErrors, function (err) {
        return !_lodash.default.get(err, 'isValid', true);
      });

      // Handle for external links
      if (externalLink) {
        var contentParts = htmlContent.split("<a>".concat(externalLink.link, "</a>"));
        externalLinkCode = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, contentParts[0], /*#__PURE__*/_react.default.createElement("a", {
          href: externalLink.link,
          target: "_blank"
        }, externalLink.text), contentParts[1]));
      }

      // Handle for popups used for tooltips
      if (popup != undefined) {
        var _contentParts = htmlContent.split("<a>".concat(popup.link, "</a>"));
        popupCode = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_FemaGoModal.default, {
          title: "",
          size: "medium",
          open: this.state.showTipsModalVisible,
          confirmButton: "hidden",
          cancelButtonText: "Close",
          cancelAction: function cancelAction() {
            return _this2.toggleToolTipsModal();
          }
        }, (0, _reactHtmlParser.default)(popup.text)), _contentParts[0], /*#__PURE__*/_react.default.createElement("a", {
          href: "javascript:void(0);",
          onClick: function onClick() {
            return _this2.toggleToolTipsModal();
          }
        }, popup.link, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: "info circle",
          size: "small",
          color: opts.bgColor
        })), _contentParts[1]);
      }
      if (sectionTitle != undefined) {
        var _contentParts2 = htmlContent.split("".concat(sectionTitle));
        navToSectionMessage = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, _contentParts2[0], /*#__PURE__*/_react.default.createElement("a", {
          href: '#' + "".concat(sectionTitle),
          onClick: function onClick() {
            return _this2.goToLocation(sectionTitle);
          }
        }, sectionTitle), _contentParts2[1]));
      }
      return opts && this.state.visible ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Message, {
        id: id || undefined,
        icon: true,
        size: size,
        onDismiss: dismissable ? function () {
          return onDismiss ? onDismiss() : _this2.handleDismiss();
        } : null,
        compact: paragraph ? true : false,
        color: opts.bgColor
      }, hideIcon == 'true' ? null : /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: opts.icon,
        size: "big",
        color: opts.bgColor
      }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Message.Content, null, header && /*#__PURE__*/_react.default.createElement(AlertHeader, null, _lodash.default.upperFirst(header)), externalLink ? externalLinkCode : popup ? popupCode : sectionTitle ? navToSectionMessage : htmlContent && (0, _reactHtmlParser.default)(htmlContent), content && (opts.paragraph ? /*#__PURE__*/_react.default.createElement("p", {
        className: "compact-paragraph"
      }, _lodash.default.upperFirst(content)) : _lodash.default.upperFirst(content)), _lodash.default.map(invalidValidationErrors, function (err) {
        return /*#__PURE__*/_react.default.createElement("p", null, _lodash.default.get(err, 'message'));
      }), this.props.children, /*#__PURE__*/_react.default.createElement("p", null, link && this.createLink(link, linkText)))) : null;
    }
  }]);
  return Alert;
}(_react.Component);
Alert.propTypes = {
  /** Switches to a compact paragraph display */
  header: _propTypes.default.string.isRequired,
  content: _propTypes.default.string,
  type: _propTypes.default.oneOf(['info', 'error', 'warning', 'success']),
  alertType: _propTypes.default.oneOf(['info', 'error', 'warning', 'success']),
  size: _propTypes.default.string,
  paragraph: _propTypes.default.bool,
  /** Makes the alert dismissable.  Will not re-show itself once dismissed. */
  dismissable: _propTypes.default.bool,
  link: _propTypes.default.string,
  linkText: _propTypes.default.string
};
Alert.defaultProps = {
  type: 'info',
  paragraph: false,
  dismissable: false,
  linkText: 'View submitted request'
};
Alert.Header = AlertHeader;
var _default = Alert;
exports.default = _default;